import type { INumberRange } from "app/UtilitiesAndConstants/types/range";

/**
 * A higher-order function
 * that normalizes a given value using the minimum-maximum normalization formula.
 * The returned function accepts a current value as input
 * and returns its normalized value based on the given ranges.
 * */

export const minMaxNormalizationHof = (fromRange: INumberRange, toRange: INumberRange) => (currentValue: number) =>
    minMaxNormalization(fromRange, toRange, currentValue);

const minMaxNormalization = (fromRange: INumberRange, toRange: INumberRange, currentValue: number) => {
    if (fromRange.from === fromRange.to) {
        return toRange.from;
    }
    const normalizedValue =
        toRange.from +
        ((currentValue - fromRange.from) * (toRange.to - toRange.from)) / (fromRange.to - fromRange.from);

    return normalizedValue;
};
